var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.copyButton)?_c('v-btn',{staticClass:"float-right ma-4",on:{"click":_vm.handleCopy}},[_vm._v(" "+_vm._s(_vm.$t("common.copy"))+" ")]):_vm._e(),_c('div',{staticClass:"text-left pb-4"},[_c('json-row',{model:{value:(_vm.json),callback:function ($$v) {_vm.json=$$v},expression:"json"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }